exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-apps-collectr-js": () => import("./../../../src/pages/apps/collectr.js" /* webpackChunkName: "component---src-pages-apps-collectr-js" */),
  "component---src-pages-apps-collectr-privacy-js": () => import("./../../../src/pages/apps/collectr/privacy.js" /* webpackChunkName: "component---src-pages-apps-collectr-privacy-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

